import React, { Component } from 'react';

export class Purchases extends Component {
  constructor() {
    super();
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header></header>
          <main className="content-wrapper">
            <table className="dsr" data-name="Purchase Summary">
              <thead>
                <tr>
                  <th colSpan={5} className="alert-brand">
                    <label className="printCheckbox">
                      <input
                        type="checkbox"
                        name="enablePrint"
                        defaultChecked="true"
                      />
                    </label>
                    Purchase Summary
                  </th>
                </tr>
                <tr data-header={true}>
                  <th>#</th>
                  <th>Invoice #</th>
                  <th>Product</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((val, key) => {
                  return (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{val.invoice_number}</td>
                      <td>{val.product}</td>
                      <td>{val.total_quantity}</td>
                      <td>
                        {new Intl.NumberFormat('en-IN', {
                          style: 'currency',
                          currency: 'INR',
                        }).format(val.total_amount.toFixed(2) || 0)}
                      </td>
                    </tr>
                  );
                })}
                <tr className="summary-row">
                  <td colSpan="4">Total </td>
                  <td>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      summary.reduce(
                        (a, b) => a + (b['total_amount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
